import Loader from '../loader';
import ErrorMessage from '../error';
import Card from '../card';
import notifyMounted from '../notify-mounted';

/**
 * This higher order component wraps a component such that it will display a loader
 * if initial data is still loading and will display an error message if that data
 * failed to load.
 *
 * props:
 * - data: loader will be displayed when set to undefined, and an error message when set to null, otherwise passed into the wrapped component as a prop
 * - retryHandler: as per the Error component
 * - retryCount: as per the Error component
 * - isLoading: as per the Error component
 * - noRetry: as per the Error component
 * - wrapLoadingErrorInCard: whether the load/error stats should be wrapped in a Card
 * - errorMessage: custom error message as per the Error component
 *
 * Any other props are passed straight down into the wrapped component.
 */
const handleLoadingAndError = (WrappedComponent) => {

	return props => {

		const { data, retryHandler, retryCount, isLoading, noRetry, errorMessage, wrapLoadingErrorInCard, mounted, ...rest } = props;

		if (data !== null && data !== undefined) {
			return <WrappedComponent data={data} mounted={mounted} {...rest} />;
		}

		let content;

		if (data === undefined) {
			content = <Loader />;
		} else {
			let ErrorComponent = typeof props.mounted === 'function'
				? notifyMounted(ErrorMessage)
				: ErrorMessage;

			content = <ErrorComponent retryHandler={retryHandler}
			                          isRetryPending={isLoading}
			                          noRetry={noRetry}
			                          message={errorMessage}
			                          retryCount={retryCount}
			                          mounted={props.mounted} />;

		}

		return wrapLoadingErrorInCard
			? <Card>{ content }</Card>
			: content;
	};

};

export default handleLoadingAndError;



// WEBPACK FOOTER //
// ./components/handle-loading-and-error/index.js